import * as THREE from 'three';

import { Pass } from 'postprocessing';

export class EDLShadePass extends Pass {
  private edlShadeMaterial: THREE.ShaderMaterial;

  private depthTexture: THREE.DepthTexture | null;

  private edlOutputTarget: THREE.WebGLRenderTarget | undefined;

  constructor(
    edlShadeMaterial: THREE.ShaderMaterial,
    edlOutputTarget: THREE.WebGLRenderTarget | undefined
  ) {
    super('EDLShadePass');

    this.edlShadeMaterial = edlShadeMaterial;
    this.fullscreenMaterial = this.edlShadeMaterial;
    this.needsDepthTexture = true;
    this.edlOutputTarget = edlOutputTarget;
    this.depthTexture = null;
  }

  render(
    renderer: THREE.WebGLRenderer,
    inputBuffer: THREE.WebGLRenderTarget,
    outputBuffer: THREE.WebGLRenderTarget
    // _deltaTime: number,
    // _stencilTest: boolean
  ) {
    this.edlShadeMaterial.uniforms.ColorTexture.value = inputBuffer.texture;
    this.edlShadeMaterial.uniformsNeedUpdate = true;

    // renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
    renderer.setRenderTarget(this.edlOutputTarget ?? outputBuffer);
    renderer.render(this.scene, this.camera);
  }

  setDepthTexture(
    depthTexture: THREE.DepthTexture
    // _depthPacking: THREE.DepthPackingStrategies | undefined
  ) {
    this.depthTexture = depthTexture;
    this.edlShadeMaterial.uniforms.DepthTexture.value = this.depthTexture;
    this.edlShadeMaterial.uniformsNeedUpdate = true;
  }

  // initialize(
  //   _renderer: THREE.WebGLRenderer,
  //   _alpha: boolean,
  //   frameBufferType: THREE.TextureDataType
  // ) {
  //   if (frameBufferType !== undefined && frameBufferType !== THREE.UnsignedByteType) {
  //     this.edlShadeMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = '1';
  //   }
  // }
}
